export class SparkJobSparkSubmitParams {
    'entryPoint';
    'entryPointArguments';
    'sparkSubmitParameters';
    'environmentVariables';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "entryPoint",
            "baseName": "entryPoint",
            "type": "string",
            "format": ""
        },
        {
            "name": "entryPointArguments",
            "baseName": "entryPointArguments",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "sparkSubmitParameters",
            "baseName": "sparkSubmitParameters",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "environmentVariables",
            "baseName": "environmentVariables",
            "type": "{ [key: string]: string; }",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SparkJobSparkSubmitParams.attributeTypeMap;
    }
    constructor() {
    }
}
